import React, { useState, useEffect } from "react";
import styles from "./CookieBanner.module.css";

const STORAGE_KEY = "softindex_cookie_consent";

export default function CookieBanner({ children }) {
  const [accepted, setAccepted] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    setAccepted(stored === "true");
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setAccepted(true);
  };

  if (accepted === null) {
    return <div className={styles.loadingPlaceholder}>{children}</div>;
  }

  if (accepted) {
    return <>{children}</>;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.contentBlur}>{children}</div>
      <div className={styles.banner}>
        <div className={styles.bannerContent}>
          <p className={styles.bannerText}>
            We use cookies and similar technologies to improve your experience and analyze usage. 
            By continuing, you accept our{" "}
            <a href="#" className={styles.link} onClick={(e) => e.preventDefault()}>
              Terms of Service
            </a>{" "}
            and{" "}
            <a href="#" className={styles.link} onClick={(e) => e.preventDefault()}>
              Privacy Policy
            </a>
            .
          </p>
          <button className={styles.acceptButton} onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
